import React, { useState } from "react"
import { usePagination } from "../../../../hooks/usePagination"
import ResultHandler from "../../../../components/ResultHandler"
import PaginationHandler from "../../../../components/PaginationHandler"
import TableHeaderHandler from "../../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import TableAction from "../../../../components/TableAction"
import EmptyData from "../../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../../api/permissions";
import { useParams, useHistory, useLocation } from "react-router-dom"
import { useResponse } from "../../../../hooks/useResponse"
import DeleteModal from "../../../../components/Common/DeleteModal"
import { formatCurrency } from "../../../../utils/formatCurrency"
import AssignReservationModal from "../../../../components/reservation-modal/AssignReservationModal"
import { Badge, Button, Col, Label, Row } from "reactstrap"
import { deleteRoom, getRooms } from "../../../../api/rooms"
import { ZoomImage } from "../../../../components/zoom-image/ZoomImage"
import TableFilter from "../../../../components/TableFilter"
import DateFromTo from "../../../../components/DateFromTo"


export default function RoomsTable() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useHistory();
  const {housingId} = useParams()
  const timeline = location.state?.timeline

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta
  } = usePagination(getRooms, {housing_id: housingId, start: timeline ? sessionStorage.getItem("clickedDate") : null})

  // Filter
  const filterTypes = [
    {key: "room_number", type: "number"},
    {key: "target_price", type: "number"},
  ]

  // const [filterInitial, setFilterInitial] = useState({})

  const dateFields = [
    {key: "start", label: "Start Date", initial: timeline ? sessionStorage.getItem("clickedDate") : null},
    {key: "end", label: "End Date"},
  ]


  // delete
  const [show, setShow] = useState(false)
  const [deletingRoom, setDeletingRoom] = useState(null)

  const { setData } = useResponse(deleteRoom, () => {
    setShow(false)
    setDeletingRoom(null)
    setPayload({ref: true, housing_id: housingId})
  })

  function onDeleteClick() {
    setData({ type: "delete", data: deletingRoom })
  }

  function onCloseClick() {
    setShow(false)
  }

  // Assign Room
  const [assignOpen, setAssignOpen] = useState(false)
  const [reservationEntity, setReservationEntity] = useState(null)


  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.HOUSING_CREATE}
        addUrl={`/add-room/${housingId}`}
        setPage={setPage}
        setPerPage={setPerPage}
      >
      </TableHeaderHandler>
      
      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) => setMeta({ page: 1, payload: {housing_id: housingId, ...filters} })}
      />

      <DateFromTo
        btnLabel="Serach for available Rooms"
        dateFields={dateFields}
        onClick={(values) => setPayload({housing_id: housingId, ...values})}
      />

      {response.data && !loading && response.data.rooms.length > 0 && <div className="mb-4 d-flex gap-2" style={{fontSize: '15px'}}>
        <b>Housing:</b>
        <span>
          {response.data.rooms[0]?.housing?.street_name} {" "}
          {response.data.rooms[0]?.housing?.number} {" "}
          {response.data.rooms[0]?.housing?.city}
        </span>
      </div>}

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Room Number</Th>
                <Th>Target Price</Th>
                <Th>Max People</Th>
                <Th>Current Reservations</Th>
                <Th>Available</Th>
                <Th>Picture</Th>
                <Th>Renters</Th>
                <Th>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.rooms.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.room_number}</Td>
                      <Td>{formatCurrency(row.target_price)}</Td>
                      <Td>{row.max_persons}</Td>
                      <Td>{row?.reservations.length}</Td>
                      <Td>
                        {row.housing?.isActive && row.reservations.length < row.max_persons
                          ? <div className="d-flex gap-2">
                              <Badge style={{fontSize: "12px"}} color='success'>
                                Available
                              </Badge>
                              <Badge style={{fontSize: "12px"}} color='success'>
                                {row.max_persons - row?.reservations?.length}
                              </Badge>
                            </div> 
                          : <Badge style={{fontSize: "12px"}} color='danger'>
                              Not Available
                            </Badge> 
                        }
                      </Td>
                      <Td>
                        {row.picture && <ZoomImage src={row.picture} alt="room image" width={150}/>}
                      </Td>
                      <Td>
                        <Button color="dark" size="sm" onClick={() => navigate.push(`/room-renters/${row.id}`, {timeline})}>View</Button>
                      </Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          editPermission={PERMISSIONS.HOUSING_EDIT}
                          hasDelete={true}
                          deletePermission={PERMISSIONS.HOUSING_DELETE}
                          type="room"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingRoom}
                        />
                        <Button style={{marginLeft: "5px"}} color="dark" onClick={() => navigate.push('/rooms/'+housingId+"/"+row.id)}>
                          <i className="bx bxs-show font-size-16 align-middle" />
                        </Button>

                          <Button color="primary" style={{marginLeft: "5px"}} className="fw-bold" 
                            onClick={() => {
                              setAssignOpen(true)
                              setReservationEntity(row)
                            }}
                          >
                            Assign
                          </Button>
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.rooms.length === 0} msg="No Rooms Found." />
          }

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}

          {/* Assign */}
          {assignOpen && <AssignReservationModal
            type="room"
            entity={reservationEntity}
            show={assignOpen}
            handleClose={() => setAssignOpen(false)}
            handleRefetch={() => {
              setPayload({ref: true, housing_id: housingId})
            }}
          />}

          <ResultHandler error={error} loading={loading} />

        </div>
      </div>
    </>
  )
}
